"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value === null || value === undefined;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isNil.js
// module id = 780
// module chunks = 0